import { useCallDetailsStore } from "@/call-details";
import type { IVRInfo } from "@/sdk";
import { isVoiceTask, useMostRecentTask, usePartner } from "@/sdk";
import { getMappedIntent } from "./getMappedIntent";

export function useIVRInfo() {
    const task = useMostRecentTask();
    const voiceTask = isVoiceTask(task) ? task : null;
    const partner = usePartner();

    const intentFromVoiceTask = voiceTask?.ivrInfo?.intent;
    const {
        INTENT: intentFromCSD,
        SUMMARY: summaryFromCSD,
        DEVICE: deviceFromCSD,
    } = useCallDetailsStore((state) => state.callDetails);

    const intent = intentFromVoiceTask ? getMappedIntent(intentFromVoiceTask, partner) : intentFromCSD;
    const summary = voiceTask?.ivrInfo?.summary ?? summaryFromCSD;
    const device = voiceTask?.ivrInfo?.device ?? deviceFromCSD;

    console.log(
        `useIVRInfo - TASK: { intent: ${intentFromVoiceTask}, summary: ${voiceTask?.ivrInfo?.summary}, device: ${voiceTask?.ivrInfo?.device} }, CSD: { intent: ${intentFromCSD}, summary: ${summaryFromCSD}, device: ${deviceFromCSD} }`,
    );

    return { ...voiceTask?.ivrInfo, intent, summary, device };
}

export function getIVRInfoFromCSD() {
    const { INTENT: intent, SUMMARY: summary, DEVICE: device } = useCallDetailsStore.getState().callDetails;
    return { intent, summary, device } as IVRInfo;
}
